import type { SalesDocType } from '../../../interfaces/src';

/**
 * Source de vérité partagée pour la numérotation des documents de vente.
 *
 * - `seq` : nom du compteur atomique par tenant (table tenant_sequence_state),
 *   consommé via l'RPC get_next_sequence_value().
 * - `defaultPrefix` : préfixe historique, utilisé en repli si company_settings
 *   n'a pas (encore) de valeur.
 * - `prefixCol` / `paddingCol` : colonnes company_settings rendues configurables
 *   par la migration 20260612120000_doc_numbering_config.sql.
 *
 * sales-repository (génération du numéro) et settings-repository (lecture/écriture
 * de la config + ajustement du prochain n°) importent tous deux cette table pour
 * rester d'accord.
 */
export interface SalesDocNumberingMeta {
  seq: string;
  defaultPrefix: string;
  prefixCol: string;
  paddingCol: string;
}

export const SALES_DOC_DEFAULT_PADDING = 4;

export const SALES_DOC_NUMBERING: Record<SalesDocType, SalesDocNumberingMeta> = {
  quote:       { seq: 'seq_quote',       defaultPrefix: 'DEV', prefixCol: 'quote_doc_prefix',       paddingCol: 'quote_doc_padding' },
  order:       { seq: 'seq_sales_order', defaultPrefix: 'CMD', prefixCol: 'order_doc_prefix',       paddingCol: 'order_doc_padding' },
  delivery:    { seq: 'seq_delivery',    defaultPrefix: 'BL',  prefixCol: 'delivery_doc_prefix',    paddingCol: 'delivery_doc_padding' },
  invoice:     { seq: 'seq_invoice',     defaultPrefix: 'FAC', prefixCol: 'invoice_doc_prefix',     paddingCol: 'invoice_doc_padding' },
  credit_note: { seq: 'seq_credit_note', defaultPrefix: 'AV',  prefixCol: 'credit_note_doc_prefix', paddingCol: 'credit_note_doc_padding' },
};

export const SALES_DOC_TYPES = Object.keys(SALES_DOC_NUMBERING) as SalesDocType[];
